import { externalEnvs, type SwitchedEnvs } from "@/helpers/switch.helpers";

// TODO incrementally roll out to environments
export const excludedMigrationEnvs: SwitchedEnvs = [
  ...externalEnvs,
  "dev",
  /se-.*$/,
];

export const PORTFOLIO_OVERVIEW_MIGRATION_FEATURE_SWITCH =
  "portfolio-overview-migration";
